module.exports = __webpack_public_path__ + "2bd23eace59729c7397db482cdcb36f5.mtl";